import * as React from "react";

export const useMapAttachedState = <K, V1, V2>(
	source: Map<K, V1>,
	initialize: (value: V1, key: K) => V2
) => {
	const [map, setMap] = React.useState(() => {
		return new Map<K, V2>();
	});

	const prevSource = React.useRef<Map<K, V1>>();

	React.useEffect(() => {
		if (prevSource.current !== source) {
			const newMap = new Map(
				Array.from(source, ([key, value]) => {
					const previousValue = map.get(key);
					return [key, previousValue === undefined ? initialize(value, key) : previousValue];
				})
			);
			setMap(newMap);
			prevSource.current = source;
		}
	}, [source, initialize, map, setMap]);

	const setValue = React.useCallback(
		(key: K, value: V2) => {
			const newMap = new Map(map);
			newMap.set(key, value);
			setMap(newMap);
		},
		[map, setMap]
	);

	return [map, setValue] as [Map<K, V2>, (key: K, value: V2) => void];
};
